import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import Helmet from 'react-helmet';
import { actions } from '../redux';
import FSFlatButton from '../../../src/components/lib/FSFlatButton';
import componentBase from '../../../src/lib/component-base';

/* eslint-disable no-useless-escape */
const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/* eslint-enable no-useless-escape */

@connect(
  state => ({
    forgotPasswordError: state.Account.forgotPasswordError,
    forgotPasswordReset: state.Account.forgotPasswordReset,
  }),
  actions,
)
@componentBase('ForgotPassword')
export default class ForgotPassword extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    forgotPassword: PropTypes.func,
    forgotPasswordError: PropTypes.array,
    forgotPasswordReset: PropTypes.bool,
    resetAuthState: PropTypes.func,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      error: null,
    };

    if (this.props.forgotPasswordReset) {
      this.forgotPasswordReset = false;
    }

    this.errorDisplayWording = {
      MISSING_EMAIL: 'An email address is required',
      UNKNOWN_USER: 'The email address provided is not in our system',
      INVALID_EMAIL: 'The email address provided is invalid',
      UNKNOWN_ERROR: 'Error',
    };
    this.login = this.login.bind(this);
    this.setEmailRef = this.setEmailRef.bind(this);
    this.email = null;
  }

  componentDidMount() {
    this.props.resetAuthState();
  }

  componentWillReceiveProps(props) {
    this.forgotPasswordReset = props.forgotPasswordReset;
  }

  getMetaTags = () => {
    const title = 'FlightStats - Forgot Password';
    return {
      title,
    };
  };

  setEmailRef = (ref) => {
    this.email = ref;
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const value = this.email && this.email.value;
    const lowerCaseValue = value && value.toLowerCase();
    if (!lowerCaseValue.length) {
      this.setState({
        error: this.errorDisplayWording.MISSING_EMAIL,
      });
    } else if (!this.testEmailAddress(lowerCaseValue)) {
      this.setState({
        error: this.errorDisplayWording.INVALID_EMAIL,
      });
    } else {
      this.props.forgotPassword(lowerCaseValue);
      this.setState({
        error: null,
      });
    }
  };

  login = () => {
    this.props.dispatch(push('/account/login'));
    this.forgotPasswordReset = false;
  };

  testEmailAddress = email => regex.test(email);

  render() {
    const meta = this.getMetaTags();
    let error = null;
    let panelStyle = null;

    if (this.state.error) {
      error = (
        <p className='account-error-text'>{this.state.error}</p>
      );
      panelStyle = 'error';
    } else if (this.props.forgotPasswordError) {
      error = (
        <p className='account-error-text'>{this.errorDisplayWording[this.props.forgotPasswordError[0]]}</p>
      );
      panelStyle = 'error';
    }

    return (
      <div className={`account-panel-split-content ${panelStyle}`}>
        <Helmet {...meta} />
        <div className='account-content'>
          <h4 className='account-title'>Forgot Your Password</h4>
          {!this.forgotPasswordReset &&
            <div className='content'>
              {error}
              <form onSubmit={this.handleSubmit}>
                <div className='account-form'>
                  <p className='account-input-title'>Email Address</p>
                  <input
                    type='email'
                    ref={this.setEmailRef}
                    placeholder='name@domain.com'
                    autoComplete='off'
                    className={`account-input ${panelStyle ? 'red' : ''}`}
                  />
                  <p className='account-description-text'>
                    {`Please provide us with the email address that you used to sign up
                      for FlightStats and we will email you a link to reset your password`}
                  </p>
                </div>
                <br />
                <div className='account-padding-div'>
                  <FSFlatButton
                    label='Continue'
                    onClick={this.handleSubmit}
                    style={FSFlatButton.style({ minWidth: '200px' })}
                  />
                </div>
              </form>
              <div className='account-padding-div'>
                <p className='account-no-account-text'>
                  Don&apos;t have a FlightStats account?
                </p>
                <Link
                  key='createNewAccount'
                  to='/register/plan'
                  className='account-link'
                  style={{ textDecoration: 'underline' }}
                >
                  <p>Create a New Account</p>
                </Link>
              </div>
            </div>
          }
          {this.forgotPasswordReset &&
          <div>
            <div style={{ margin: '10px 0' }}>
              <p className='account-description-text'>
                {`We sent you an email that contains a link to change your password.
                  The password for the beta site is the same password for your account on flightstats.com.`}
              </p>
            </div>
            <br /><br />
            <div className='account-padding-div'>
              <FSFlatButton
                label='Login'
                style={FSFlatButton.style({ minWidth: '200px' })}
                onClick={this.login}
              />
            </div>
          </div>
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Account/components/ForgotPassword.js